import { render } from "./IndexRda.vue?vue&type=template&id=7afcfcc6"
import script from "./IndexRda.vue?vue&type=script&lang=js"
export * from "./IndexRda.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__